module.exports = __webpack_public_path__ + "static/Ranger 1-7cedaba5ff4ec7356a28cf7b142219b5.jpg";